import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Link } from 'components/ui';
import { colors, fontSizes } from 'style/config';

function RemoveLink({ onClick, getText }) {
    return (
        <Link
            onClick={onClick}
            css={styles.removeLink}
        >
            {getText('remove')}
        </Link>
    );
}

const styles = {
    removeLink: {
        fontSize: `${fontSizes.sm}px`,
        lineHeight: '14px',
        color: colors.blue,
        cursor: 'pointer'
    }
};

RemoveLink.propTypes = {
    onClick: PropTypes.func.isRequired,
    getText: PropTypes.func.isRequired
};

export default wrapFunctionalComponent(RemoveLink, 'RemoveLink');
